var render, staticRenderFns
import script from "./BitrixShippersForm.vue?vue&type=script&lang=js&"
export * from "./BitrixShippersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701b7878",
  null
  
)

export default component.exports